exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div_navigationItem:hover {\n  border-bottom: 1px solid #00b4d2 !important;\n}\n\n.div_navigationItem:hover a p {\n  color: #00b4d2 !important;\n}\n\n.div_navigationItem_last {\n  padding: 0px 0px 0px 30px !important;\n}\n.div_navigationItem_first {\n  padding: 0px 30px 0px 0px !important;\n}\n\n.div_navigationItem_Selected {\n  border-bottom: 1px solid #00b4d2 !important;\n}\n\n.div_navigationItem_Selected a p {\n  color: #00b4d2 !important;\n}\n", ""]);

// exports
